import React, { useEffect, useState } from 'react'
import { Show } from 'data/Show'
import { showHasStarted, showHasEnded } from 'utils/show'
import { CountdownTimeDeltaFormatted, formatTimeDelta, calcTimeDelta } from 'react-countdown-now'
import { useStyles } from './styles'

interface ShowDurationProps {
    show: Show
}

const initialTime = {
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
}

const ShowDuration: React.FC<ShowDurationProps> = ({ show }) => {
    const classes = useStyles()
    const [time, setTime] = useState<CountdownTimeDeltaFormatted>(initialTime)

    useEffect(() => {
        if (!show) return

        const timeout = setInterval(() => {
            const currentTime = formatTimeDelta(
                calcTimeDelta(Date.now(), {
                    now: () => +new Date(show.startTime),
                }),
            )

            if (showHasStarted(show)) {
                setTime(currentTime)
            }

            if (showHasEnded(show)) {
                setTime(initialTime)
                clearInterval(timeout)
            }
        }, 1000)

        return () => clearInterval(timeout)
    }, [show])

    return (
        <p className={classes.showDuration}>
            {time.hours}:{time.minutes}:{time.seconds}
        </p>
    )
}

export default ShowDuration
